<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <div class="vx-row pt-2">
        <vs-button size="small" class="mr-2 px-3" color="primary" type="filled" icon-pack="feather" icon="icon-move" @click="moveToCashBook"></vs-button>
        <vs-button size="small" class="mr-2 px-3" color="success" type="filled" icon-pack="feather" icon="icon-edit" @click="editRecord"></vs-button>
        <vs-button size="small" class="px-3" color="danger" type="filled" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord"></vs-button>
      </div>
      <vs-popup title="Pindahkan Bon Sementara" :active.sync="movePopup">
        <label for="temporary-destination">Cashbook tujuan</label>
        <select id="temporary-destination" v-model="destination" class="w-full p-3 mb-4" :disabled="loading || moving">
          <option disabled value="">Pilih cashbook tujuan</option>
          <option v-for="book in cashbooks" :key="book.id" :value="book.id">{{ book.name }}</option>
        </select>
        <p v-if="loading">Memuat cashbook...</p>
        <p v-else-if="!cashbooks.length">Tidak ada cashbook yang tersedia.</p>
        <vs-button :disabled="!destination || moving || loading" @click="moveRecord">{{ moving ? 'Memindahkan...' : 'Pindahkan' }}</vs-button>
      </vs-popup>
    </div>
</template>

<script>
import moment from 'moment'
import axios from '@/axios.js'
export default {
  name: 'CellRendererActions',
  data () {
    return { movePopup: false, destination: '', cashbooks: [], loading: false, moving: false }
  },
  methods: {
    editRecord () {
      this.$router.push(`/cash-book-temporary/edit/${this.params.data.id}`).catch(() => {})
    },
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Perhatian',
        text: `Anda akan menghapus "${this.params.data.id}" ?`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      const self = this
      this.$store.dispatch('cashBookTemporary/deleteCashBookTemporary', this.params.data.id)
        .then(function () {
          self.params.getCashBookTemporary()
          self.showDeleteSuccess()
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Berhasil',
        text: 'Bon Sementara terpilih berhasil dihapus'
      })
    },
    async moveToCashBook () {
      this.destination = ''
      this.cashbooks = []
      this.movePopup = true
      this.loading = true
      try {
        const response = await axios.get('/cashflow/cashbooks')
        this.cashbooks = response.data.data || []
      } catch (error) {
        this.$vs.notify({ color: 'danger', title: 'Gagal memuat cashbook', text: 'Silakan coba lagi.' })
      } finally {
        this.loading = false
      }
    },
    moveRecord () {
      if (!this.destination || this.moving) return
      this.moving = true
      const self = this
      
      const formData = {
        date_out: moment().format('DD-MM-YYYY'),
        cashbook_id: this.destination
      }

      this.$store.dispatch('cashBookTemporary/updateCashBookTemporary', {
        id: this.params.data.id,
        data: formData
      })
        .then(function () {
          self.movePopup = false
          self.params.getCashBookTemporary()
          self.$vs.notify({
            color: 'success',
            title: 'Berhasil',
            text: 'Bon Sementara terpilih berhasil dipindahkan'
          })
        })
        .catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: (err.response && err.response.data && err.response.data.message) || 'Pemindahan gagal. Silakan coba lagi.'
          })
        })
        .finally(() => { this.moving = false })
    }
  }
}
</script>
